import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import * as feedAdviceActions from '../store/feed-advice.actions';

@Injectable({
  providedIn: 'root',
})
export class FeedAdvicesGuard {
  constructor(private readonly store: Store<RootState>) {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(feedAdviceActions.loadData());
    return of(true);
  }
}
